import { createContext } from 'react';

// Permette a una pagina (es. Liste) di registrare il tasto "Filtri" nella top bar.
// value = setFilterReg(reg) dove reg = { onOpen, count } | null
export const FilterBarContext = createContext(() => {});
